/* eslint-disable prettier/prettier */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MaterialGrid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Alert } from '@material-ui/lab';
import PrimaryButton from 'common/components/buttons/primaryButton';
import SecondaryButton from 'common/components/buttons/secondaryButton';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, getFormValues, change } from 'redux-form';
import { getPartners } from '../vendasOnlineParceiroActions';

const bankNames = {
  '001': 'Banco do Brasil',
  '033': 'Santander',
  '104': 'Caixa Econômica Federal',
  '237': 'Bradesco',
  '341': 'Itaú',
  '356': 'ABN Amro Real',
  '389': 'Banco Mercantil do Brasil',
  '399': 'HSBC',
  '422': 'Safra',
  '453': 'Banco Rural',
  '633': 'Banco Rendimento',
  '652': 'Itaú Unibanco',
  '745': 'Citibank',
  '260': 'Nu Pagamentos (Nubank)',
  '290': 'Pagseguro Internet',
  '323': 'Mercado Pago',
  '403': 'Cora',
};

const getBankName = (bankCode) => {
  return bankNames[bankCode] || `Banco ${bankCode}`;
};

class Parceiros extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasPartner: props.formValues?.has_partner || false,
      partnersSplit: props.formValues?.partners_split || [],
    };
  }

  componentDidMount() {
    this.loadPartners();
    
    // Carregar parceiros salvos
    if (this.props.formValues?.partners_split) {
      this.setState({ partnersSplit: this.props.formValues.partners_split });
    }
    if (this.props.formValues?.has_partner !== undefined) {
      this.setState({ hasPartner: this.props.formValues.has_partner });
    }
  }

  componentDidUpdate(prevProps) {
    // Recarregar parceiros se as stations selecionadas mudarem
    const prevStations = prevProps.formValues?.stations_field || [];
    const currentStations = this.props.formValues?.stations_field || [];
    
    const prevIds = prevStations.map(s => s.id).sort().join(',');
    const currentIds = currentStations.map(s => s.id).sort().join(',');
    
    if (prevIds !== currentIds) {
      this.loadPartners();
    }
  }

  loadPartners = () => {
    // Pegar todas as stations selecionadas no formulário
    const selectedStations = this.props.formValues?.stations_field || [];
    
    // Se não houver stations selecionadas, usar todas as stations do usuário
    let stationIds = [];
    if (selectedStations.length > 0) {
      stationIds = selectedStations.map(s => s.id);
    } else {
      // Pegar todas as stations de todos os establishments do usuário
      const establishments = this.props.auth.user.establishments || [];
      establishments.forEach(est => {
        if (est.stations) {
          est.stations.forEach(station => {
            stationIds.push(station.id);
          });
        }
      });
    }

    if (stationIds.length > 0) {
      this.props.getPartners(stationIds);
    }
  };

  handleTogglePartner = (event) => {
    const hasPartner = event.target.checked;
    this.setState({ hasPartner });
    this.props.change('has_partner', hasPartner);
    
    if (!hasPartner) {
      this.setState({ partnersSplit: [] });
      this.props.change('partners_split', []);
    }
  };

  handleAddPartner = () => {
    const newPartner = {
      id: null,
      user_id: null,
      name: '',
      cnpj: '',
      email: '',
      percentage: 0,
      recipient_id: '',
    };
    
    const updatedPartners = [...this.state.partnersSplit, newPartner];
    this.setState({ partnersSplit: updatedPartners });
    this.props.change('partners_split', updatedPartners);
  };

  handleRemovePartner = (index) => {
    const updatedPartners = this.state.partnersSplit.filter((_, i) => i !== index);
    this.setState({ partnersSplit: updatedPartners });
    this.props.change('partners_split', updatedPartners);
  };

  handlePartnerChange = (index, partner) => {
    const updatedPartners = [...this.state.partnersSplit];
    
    // Pegar a primeira conta digital disponível (se houver)
    const firstAccount = partner?.accounts?.[0];
    
    // Formatar número da conta com dígito verificador
    const accountNumber = firstAccount?.account_number 
      ? `${firstAccount.account_number}${firstAccount.account_dv ? '-' + firstAccount.account_dv : ''}`
      : '';
    
    updatedPartners[index] = {
      ...updatedPartners[index],
      id: partner?.user_id || partner?.id,
      user_id: partner?.user_id || partner?.id,
      establishment_id: partner?.establishment_id,
      name: partner?.name || '',
      establishment_name: partner?.establishment_name || '',
      cnpj: partner?.cpf_cnpj || partner?.cnpj || '', // cpf_cnpj vem do mapeamento na action
      email: partner?.email || '',
      recipient_id: firstAccount?.external_id || '',
      account_id: firstAccount?.local_id || null,
      bank_code: firstAccount?.bank_code || '',
      agency: firstAccount?.agency || '',
      account_number: accountNumber,
      account_name: firstAccount?.account_name || '',
      hasDigitalAccount: partner?.hasDigitalAccount || false,
      accounts: partner?.accounts || [],
    };
    this.setState({ partnersSplit: updatedPartners });
    this.props.change('partners_split', updatedPartners);
  };

  handlePercentageChange = (index, percentage) => {
    const updatedPartners = [...this.state.partnersSplit];
    updatedPartners[index] = {
      ...updatedPartners[index],
      percentage: parseFloat(percentage) || 0,
    };
    this.setState({ partnersSplit: updatedPartners });
    this.props.change('partners_split', updatedPartners);
  };

  calculateStationPercentage = () => {
    const totalPartnerPercentage = this.state.partnersSplit.reduce(
      (sum, p) => sum + (parseFloat(p.percentage) || 0),
      0
    );
    return Math.max(0, 100 - totalPartnerPercentage);
  };

  onSubmit = (values) => {
    values.has_partner = this.state.hasPartner;
    values.partners_split = this.state.partnersSplit;
    values.station_percentage = this.calculateStationPercentage();
    
    // Salvar no Redux Form
    this.props.change('has_partner', this.state.hasPartner);
    this.props.change('partners_split', this.state.partnersSplit);
    this.props.change('station_percentage', this.calculateStationPercentage());
    
    // Avançar para próxima aba
    this.props.onClickProgress();
  };

  render() {
    const { handleSubmit, partners, loading } = this.props;
    const { hasPartner, partnersSplit } = this.state;
    const stationPercentage = this.calculateStationPercentage();
    const totalPercentage = partnersSplit.reduce((sum, p) => sum + (parseFloat(p.percentage) || 0), 0);
    const isValid = totalPercentage <= 100;

    return (
      <form onSubmit={handleSubmit(this.onSubmit)}>
        <div style={{ overflowY: 'scroll', height: 'calc(100vh - 355px)', padding: '0 10px' }}>
          {/* Toggle Parceiro */}
          <Box style={{ marginBottom: 24 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={hasPartner}
                  onChange={this.handleTogglePartner}
                  color="primary"
                />
              }
              label="Atividade relacionada com parceiro?"
            />
          </Box>

          {hasPartner && (
            <>
              {/* Lista de Parceiros */}
              {partnersSplit.map((partnerSplit, index) => (
                <Paper key={index} style={{ padding: 16, marginBottom: 16 }}>
                  <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <Typography variant="subtitle2">Parceiro {index + 1}</Typography>
                    <IconButton
                      size="small"
                      onClick={() => this.handleRemovePartner(index)}
                      style={{ color: '#f44336' }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>

                  {/* Seleção do Parceiro */}
                  <Autocomplete
                    options={partners || []}
                    getOptionLabel={(option) => {
                      if (!option) return '';
                      return option.establishment_name 
                        ? `${option.name} - ${option.establishment_name}`
                        : option.name || '';
                    }}
                    value={partners?.find((p) => 
                      p.user_id === partnerSplit.user_id && 
                      p.establishment_id === partnerSplit.establishment_id
                    ) || null}
                    onChange={(event, newValue) => this.handlePartnerChange(index, newValue)}
                    loading={loading}
                    noOptionsText="Nenhum parceiro encontrado"
                    loadingText="Carregando parceiros..."
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecione o Parceiro"
                        variant="outlined"
                        size="small"
                        fullWidth
                        helperText={partners?.length === 0 ? 'Nenhum parceiro cadastrado nas stations selecionadas' : ''}
                      />
                    )}
                    renderOption={(option) => (
                      <Box>
                        <Typography variant="body2">
                          {option.name}
                          {option.establishment_name && (
                            <span style={{ color: '#666', marginLeft: 8 }}>
                              ({option.establishment_name})
                            </span>
                          )}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          {option.email}
                          {option.hasDigitalAccount && ' ✓ Conta digital'}
                        </Typography>
                      </Box>
                    )}
                    style={{ marginBottom: 16 }}
                  />

                  {/* Dados do Parceiro (auto-preenchidos) */}
                  {partnerSplit.user_id && (
                    <>
                      <MaterialGrid container spacing={2}>
                        <MaterialGrid item xs={12} sm={6}>
                          <TextField
                            label="Nome"
                            value={partnerSplit.name || ''}
                            disabled
                            fullWidth
                            size="small"
                          />
                        </MaterialGrid>
                        <MaterialGrid item xs={12} sm={6}>
                          <TextField
                            label="Estabelecimento"
                            value={partnerSplit.establishment_name || ''}
                            disabled
                            fullWidth
                            size="small"
                          />
                        </MaterialGrid>
                        <MaterialGrid item xs={12} sm={6}>
                          <TextField
                            label="CNPJ/CPF"
                            value={partnerSplit.cnpj || partnerSplit.accounts?.[0]?.cpf_cnpj || ''}
                            disabled
                            fullWidth
                            size="small"
                          />
                        </MaterialGrid>
                        <MaterialGrid item xs={12} sm={6}>
                          <TextField
                            label="E-mail"
                            value={partnerSplit.email || ''}
                            disabled
                            fullWidth
                            size="small"
                          />
                        </MaterialGrid>
                        
                        {/* Dados Bancários */}
                        {partnerSplit.hasDigitalAccount && (
                          <>
                            <MaterialGrid item xs={12}>
                              <Typography variant="caption" color="textSecondary" style={{ marginTop: 8 }}>
                                Dados Bancários
                              </Typography>
                            </MaterialGrid>
                            <MaterialGrid item xs={12} sm={4}>
                              <TextField
                                label="Banco"
                                value={partnerSplit.bank_code ? getBankName(partnerSplit.bank_code) : ''}
                                disabled
                                fullWidth
                                size="small"
                              />
                            </MaterialGrid>
                            <MaterialGrid item xs={12} sm={4}>
                              <TextField
                                label="Agência"
                                value={partnerSplit.agency || ''}
                                disabled
                                fullWidth
                                size="small"
                              />
                            </MaterialGrid>
                            <MaterialGrid item xs={12} sm={4}>
                              <TextField
                                label="Conta"
                                value={partnerSplit.account_number || ''}
                                disabled
                                fullWidth
                                size="small"
                              />
                            </MaterialGrid>
                            {partnerSplit.account_name && (
                              <MaterialGrid item xs={12}>
                                <TextField
                                  label="Titular da Conta"
                                  value={partnerSplit.account_name || ''}
                                  disabled
                                  fullWidth
                                  size="small"
                                />
                              </MaterialGrid>
                            )}
                          </>
                        )}
                        
                        <MaterialGrid item xs={12} sm={6}>
                          <TextField
                            label="Percentual (%)"
                            type="number"
                            value={partnerSplit.percentage}
                            onChange={(e) => this.handlePercentageChange(index, e.target.value)}
                            inputProps={{ min: 0, max: 100, step: 0.01 }}
                            fullWidth
                            size="small"
                          />
                        </MaterialGrid>
                      </MaterialGrid>

                      {!partnerSplit.hasDigitalAccount && (
                        <Alert severity="warning" style={{ marginTop: 16 }}>
                          Este parceiro não possui conta digital cadastrada. O split de pagamento não será possível.
                        </Alert>
                      )}
                    </>
                  )}
                </Paper>
              ))}

              {/* Botão Adicionar Parceiro */}
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={this.handleAddPartner}
                fullWidth
                style={{ marginBottom: 24 }}
              >
                Adicionar Parceiro
              </Button>

              {/* Resumo do Split */}
              {partnersSplit.length > 0 && (
                <Paper style={{ padding: 16, marginBottom: 16, backgroundColor: '#f5f5f5' }}>
                  <Typography variant="subtitle2" gutterBottom>
                    Resumo da Divisão
                  </Typography>
                  {partnersSplit.map((p, i) => (
                    <Box key={i} style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2">{p.name || `Parceiro ${i + 1}`}</Typography>
                      <Typography variant="body2">{p.percentage}%</Typography>
                    </Box>
                  ))}
                  <Box
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      borderTop: '1px solid #ddd',
                      marginTop: 8,
                      paddingTop: 8,
                    }}
                  >
                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                      Estação
                    </Typography>
                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                      {stationPercentage.toFixed(2)}%
                    </Typography>
                  </Box>
                  <Box style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8 }}>
                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                      Total
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{ fontWeight: 'bold', color: isValid ? 'green' : 'red' }}
                    >
                      {(totalPercentage + stationPercentage).toFixed(2)}%
                    </Typography>
                  </Box>
                </Paper>
              )}

              {!isValid && (
                <Alert severity="error" style={{ marginBottom: 16 }}>
                  A soma dos percentuais não pode ultrapassar 100%
                </Alert>
              )}
            </>
          )}
        </div>

        {/* Botões */}
        <MaterialGrid
          container
          display="flex"
          justifyContent="space-around"
          alignItems="center"
          style={{ margin: '25px 0px', overflowX: 'hidden' }}>
          <SecondaryButton
            type="button"
            color="secondary"
            onClick={this.props.goBack}
            style={{ margin: 0, width: '48%', padding: '10px 20px', textTransform: 'none' }}>
            Voltar
          </SecondaryButton>
          <PrimaryButton
            type="submit"
            color="primary"
            disabled={hasPartner && !isValid}
            style={{ margin: 0, width: '48%', padding: '10px 20px', textTransform: 'none' }}>
            Salvar e continuar
          </PrimaryButton>
        </MaterialGrid>

      </form>
    );
  }
}

Parceiros.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  formValues: PropTypes.object,
  onClickProgress: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  handleCancelClose: PropTypes.func.isRequired,
  openConfirmation: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  confirmationTitle: PropTypes.string,
  confirmationSubtitle: PropTypes.string,
  buttonConfirmationLabel: PropTypes.string,
  auth: PropTypes.object.isRequired,
  change: PropTypes.func.isRequired,
  partners: PropTypes.array,
  loading: PropTypes.bool,
  getPartners: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  formValues: getFormValues('vendasOnlineParceiroForm')(state),
  partners: state.vendasOnlineParceiro?.partners || [],
  loading: state.vendasOnlineParceiro?.loading || false,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      change: (field, value) => change('vendasOnlineParceiroForm', field, value),
      getPartners,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'vendasOnlineParceiroForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(Parceiros)
);
